<script>
import { defineComponent as _defineComponent } from "vue";
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "magic-marquee__track" };
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useMarqueeApi } from "../composables/private/useMarqueeApi";
import { useMarqueeState } from "../composables/private/useMarqueeState";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicMarquee",
  props: {
    id: { type: null, required: true },
    options: { type: Object, required: false }
  },
  setup(__props) {
    const { deleteState, initializeState } = useMarqueeState(__props.id);
    initializeState(__props.options);
    const parentRef = ref(void 0);
    const childRef = ref(void 0);
    const { duplicates, initialize } = useMarqueeApi({
      child: childRef,
      parent: parentRef,
      instanceId: __props.id
    });
    onMounted(() => {
      initialize();
    });
    onBeforeUnmount(() => {
      deleteState();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(
        "div",
        {
          ref_key: "parentRef",
          ref: parentRef,
          class: "magic-marquee"
        },
        [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode(
              "div",
              {
                ref_key: "childRef",
                ref: childRef,
                class: "magic-marquee__content"
              },
              [
                _renderSlot(_ctx.$slots, "default")
              ],
              512
              /* NEED_PATCH */
            ),
            (_openBlock(true), _createElementBlock(
              _Fragment,
              null,
              _renderList(_unref(duplicates), (duplicate) => {
                return _openBlock(), _createElementBlock("div", {
                  key: duplicate,
                  class: "magic-marquee__content",
                  "aria-hidden": true
                }, [
                  _renderSlot(_ctx.$slots, "default")
                ]);
              }),
              128
              /* KEYED_FRAGMENT */
            ))
          ])
        ],
        512
        /* NEED_PATCH */
      );
    };
  }
});
</script>

<style>
@keyframes mm-scroll-x {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-100%, 0, 0);
  }
}

@keyframes mm-scroll-y {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, -100%, 0);
  }
}

.magic-marquee {
  position: relative;
  width: 100%;
  overflow: hidden;
  user-select: none;
}

.magic-marquee__track {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: var(--magic-marquee-justify-content, flex-start);
  align-items: var(--magic-marquee-align-items, baseline);
}

.magic-marquee__content {
  white-space: nowrap;
  backface-visibility: hidden;
  padding-right: var(--magic-marquee-gap, 1rem);
  width: var(--magic-marquee-content-width, unset);
  animation-name: var(--mm-animation-name, 'mm-scroll-x');
  animation-duration: var(--mm-animation-duration);
  animation-play-state: var(--mm-animation-play-state, running);
  animation-direction: var(--mm-animation-direction, normal);
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  display: flex;
  gap: var(--magic-marquee-gap, 1rem);
  flex-shrink: 0;
  flex-grow: 0;
}
</style>
